export const STORAGE_KEY_BENEFICIAIRE = 'beneficiaire';
export const STORAGE_KEY_USER = 'user';
export const STORAGE_KEY_CE = 'ce';
export const STORAGE_KEY_VERSION = 'version';



// WEBPACK FOOTER //
// ./src/shared/services/storage/constant-key.ts